import Vue from 'vue';
/**
 * Renders a progressbar.
 *
 * *Props*
 * * striped: should this bar have a stripe affect?
 * * active: should this bar be animated?
 * * percent: what percentage complete is this bar?
 * * color: What color is this bar? {green, blue, red, orange}. Default is blue.
 * * size: How big is this bar? {small, medium, large, xlarge}. Default is medium
 * * label: Content of the label to show below the bar. Default is blank.
 * * showProgressLabel: Show a text label in the bar indicating % complete. Defaults to false.
 */
export default Vue.extend({
    props: {
        striped: { type: Boolean, default: true },
        active: { type: Boolean, default: false },
        percent: { type: Number, default: 0 },
        color: { type: String, default: 'blue' },
        size: { type: String, default: 'medium' },
        label: { type: String, default: null },
        showProgressLabel: { type: Boolean, default: true }
    }
});
